var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#012631"
    },
    points: "256,0 202.294,229.147 256,512 512,512 512,0 "
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#4F575B"
    },
    width: 256,
    height: 512
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 271,
    style: {
      fill: "#FFCD37"
    },
    width: 196,
    height: 211
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 30,
    style: {
      fill: "#FFCD37"
    },
    width: 196,
    height: 211
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 286,
    y: 271,
    style: {
      fill: "#FFAB37"
    },
    width: 196,
    height: 211
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286,
    y: 30,
    style: {
      fill: "#FFAB37"
    },
    width: 196,
    height: 211
  })), /*#__PURE__*/React.createElement("rect", {
    x: 422,
    y: 180.5,
    style: {
      fill: "#FFEEBC"
    },
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166,
    y: 180,
    style: {
      fill: "#FFFFFF"
    },
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422,
    y: 422,
    style: {
      fill: "#FFEEBC"
    },
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362,
    y: 60.5,
    style: {
      fill: "#012631"
    },
    width: 90,
    height: 90
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 60,
    style: {
      fill: "#4F575B"
    },
    width: 90,
    height: 90
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362,
    y: 302,
    style: {
      fill: "#012631"
    },
    width: 90,
    height: 90
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 301.5,
    style: {
      fill: "#4F575B"
    },
    width: 90,
    height: 90
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166,
    y: 421.5,
    style: {
      fill: "#FFFFFF"
    },
    width: 30,
    height: 30
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocker);
export default __webpack_public_path__ + "static/media/locker.6206120e70c1c7a8227722e2e5059d1b.svg";
export { ForwardRef as ReactComponent };